module.exports = __webpack_public_path__ + "static/media/rhodes_0003_mercedes.51b8de4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0003_mercedes.jpg
// module id = 166
// module chunks = 0